(function () {
  function initialiseStyleTabs(wrapper) {
    if (!wrapper || wrapper.dataset.tabsInitialised === 'true') return;

    var buttons = Array.prototype.slice.call(wrapper.querySelectorAll('.outfit-collection-tabs__tab-btn'));
    var panels = Array.prototype.slice.call(wrapper.querySelectorAll('.outfit-collection-tabs__panel'));

    function activateTab(button, moveFocus) {
      var index = button.getAttribute('data-tab-index');

      buttons.forEach(function (item) {
        var isActive = item === button;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === index;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (moveFocus) button.focus();
    }

    buttons.forEach(function (button, buttonIndex) {
      button.addEventListener('click', function () {
        activateTab(button, false);
      });

      button.addEventListener('keydown', function (event) {
        var targetIndex = buttonIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (buttonIndex + 1) % buttons.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (buttonIndex - 1 + buttons.length) % buttons.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = buttons.length - 1;

        if (targetIndex !== buttonIndex) {
          event.preventDefault();
          activateTab(buttons[targetIndex], true);
        }
      });
    });

    wrapper.dataset.tabsInitialised = 'true';
  }

  function initialiseAllStyleTabs(scope) {
    var root = scope || document;
    var wrappers = root.matches && root.matches('.outfit-collection-tabs')
      ? [root]
      : root.querySelectorAll('.outfit-collection-tabs');

    Array.prototype.forEach.call(wrappers, initialiseStyleTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAllStyleTabs(document);
    });
  } else {
    initialiseAllStyleTabs(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAllStyleTabs(event.target);
  });
})();